
import base from "./base.service";

const instance = base.service(); 

export const getAll = () => {
    return instance.get("/statistikaDokumenta/all"); 
};

export const deleteStatistikaDokumenta = (id) =>
{
    return instance.delete(`/statistikaDokumenta/${id}`);
}

export const addStatistikaDokumenta = (novaStatistikaDokumenta) =>
{
    return instance.post(`/statistikaDokumenta`, novaStatistikaDokumenta);
}

export const getById = (id) =>
{
    return instance.get(`/statistikaDokumenta/${id}`);
}

export const getAllByDokumentId = (id) =>
    {
        return instance.get(`/statistikaDokumenta/dokument/${id}`);
    }

    export const getCountAll = () =>
        {
            return instance.get(`/statistikaDokumenta/ukupno`);
        }


    export const getCountByDokumentId = (id) => {
        return instance.get(`/statistikaDokumenta/dokument/${id}/ukupno`);
    };

    export const getCountByDokumentIdAndDateRange = (id, startDate, endDate) => {
        return instance.get(`/statistikaDokumenta/dokument/${id}/ukupnoUnutarOpsega`, {
            params: { startDate, endDate }
        });
    };
    

    export const getByDokumentIdAndDateRange = (id, startDate, endDate) => {
        return instance.get(`/statistikaDokumenta/dokument/${id}/sviUnutarOpsega`, {
            params: { startDate, endDate }
        });
    };


export default {
    getAll,deleteStatistikaDokumenta,addStatistikaDokumenta, getById, getAllByDokumentId,
     getCountByDokumentId, getCountByDokumentIdAndDateRange, getByDokumentIdAndDateRange, getCountAll
};
